import { setHours, setMinutes, setSeconds } from 'date-fns'

export function useStartDateAndTime() {
  function mergeDateAndTime({
    startTime,
    selectedDate,
  }: {
    startTime: Date
    selectedDate: Date
  }) {
    const hours = startTime.getHours()
    const minutes = startTime.getMinutes()
    const seconds = startTime.getSeconds()

    const mergedDate = setHours(
      setMinutes(setSeconds(selectedDate, seconds), minutes),
      hours,
    )

    return mergedDate.toISOString()
  }

  return { mergeDateAndTime }
}
